// extracted by mini-css-extract-plugin
export default {"informations":"informations_informations__f6Qa1","loader":"informations_loader__DD2qc","containerField":"informations_containerField__JQuD3"};